<template>
    <v-menu offset-y>
        <template #activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" icon v-on="on">
                <v-icon>mdi-share</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="platform in shareablePlatforms" :key="platform.key" @click="share(platform)">
                <template v-if="platform.key === 'link'">
                    <v-list-item-icon>
                        <v-icon>{{ platform.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{ platform.title }}
                        <input ref="copy-link" type="hidden" :value="shareableMetadata.url" />
                    </v-list-item-title>
                </template>

                <template v-else>
                    <v-list-item-icon>
                        <v-icon>{{ platform.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        <ShareNetwork
                            :ref="platform.key"
                            :title="shareableMetadata.title"
                            :url="shareUrl"
                            :network="platform.key"
                            :media="get(shareableMetadata, 'images.0')"
                            twitter-user="scorsync"
                            hashtags="scorsync"
                        >
                            {{ platform.title }}
                        </ShareNetwork>
                    </v-list-item-title>
                </template>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import get from 'lodash/get.js';
import Result from '@/Models/Result.js';

export default {
    name: 'ScorsyncShare',

    props: {
        platforms: {
            type: Array,
            required: false,
            default: () => ['facebook', 'twitter', 'link', 'email'],
        },

        result: {
            type: Result,
            required: true,
        },

        round: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        availablePlatforms: [
            { key: 'facebook', title: 'Facebook', icon: 'mdi-facebook' },
            { key: 'twitter', title: 'Twitter', icon: 'mdi-twitter' },
            { key: 'link', title: 'Copy Link', icon: 'mdi-link' },
            { key: 'email', title: 'Email', icon: 'mdi-email' },
        ],
    }),

    computed: {
        shareablePlatforms() {
            return this.availablePlatforms.filter(item => this.platforms.includes(item.key));
        },

        shareUrl() {
            if (window.location.search.includes(`share=${this.result.id}`)) {
                return window.location.href;
            }
            return `${window.location.href}?share=${this.result.id}`;
        },

        shareableMetadata() {
            return this.result.shareableMetadata(this.round);
        },
    },

    methods: {
        get,

        share(platform) {
            if (platform.key === 'link') {
                navigator.clipboard.writeText(this.shareableMetadata.url);
            } else {
                this.$refs[platform.key][0].share();
            }
        },
    },
};
</script>
